import api from './api';

const toFormData = (data) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            return;
        }
        if (typeof value === 'boolean') {
            formData.append(key, value ? '1' : '0');
            return;
        }
        if (typeof value === 'object' && !(value instanceof File)) {
            formData.append(key, JSON.stringify(value));
            return;
        }
        formData.append(key, value);
    });
    return formData;
};

export const adminAuthService = {
    login: (email, password) => api.post('/auth/login', { email, password }),
    logout: () => api.post('/auth/logout'),
    getCurrentUser: () => api.get('/auth/me'),
    updateProfile: (data) => api.put('/auth/profile', data),
    changePassword: (data) => api.post('/auth/change-password', data),
};

export const adminDashboardService = {
    getStats: () => api.get('/admin/dashboard/stats'),
    getActivities: (limit = 10) => api.get('/admin/dashboard/activities', { params: { limit } }),
};

export const adminProjectService = {
    getAll: (params = {}) => api.get('/admin/projects', { params }),
    getById: (id) => api.get(`/admin/projects/${id}`),
    create: (data) => api.post('/admin/projects', toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    update: (id, data) => api.put(`/admin/projects/${id}`, toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/admin/projects/${id}`),
};

export const adminEventService = {
    getAll: (params = {}) => api.get('/admin/events', { params }),
    getById: (id) => api.get(`/admin/events/${id}`),
    create: (data) => api.post('/admin/events', toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    update: (id, data) => api.put(`/admin/events/${id}`, toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/admin/events/${id}`),
};

export const adminBlogService = {
    getAll: (params = {}) => api.get('/admin/blogs', { params }),
    getById: (id) => api.get(`/admin/blogs/${id}`),
    create: (data) => api.post('/admin/blogs', toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    update: (id, data) => api.put(`/admin/blogs/${id}`, toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/admin/blogs/${id}`),
};

export const adminGalleryService = {
    getAll: (params = {}) => api.get('/admin/gallery', { params }),
    getCategories: () => api.get('/gallery/categories'),
    createCategory: (name) => api.post('/admin/gallery/categories', { name }),
    deleteCategory: (id) => api.delete(`/admin/gallery/categories/${id}`),
    upload: (data) => api.post('/admin/gallery', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/admin/gallery/${id}`),
};

export const adminDonationService = {
    getAll: (params = {}) => api.get('/admin/donations', { params }),
    getById: (id) => api.get(`/admin/donations/${id}`),
    updateStatus: (id, status) => api.put(`/admin/donations/${id}/status`, { status }),
    delete: (id) => api.delete(`/admin/donations/${id}`),
};

export const adminCampaignService = {
    getAll: (params = {}) => api.get('/admin/campaigns', { params }),
    getById: (id) => api.get(`/admin/campaigns/${id}`),
    create: (data) => api.post('/admin/campaigns', toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    update: (id, data) => api.put(`/admin/campaigns/${id}`, toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/admin/campaigns/${id}`),
};

export const adminAdvisoryBoardService = {
    getAll: (params = {}) => api.get('/admin/advisory-board', { params }),
    create: (data) => api.post('/admin/advisory-board', toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    update: (id, data) => api.put(`/admin/advisory-board/${id}`, toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/admin/advisory-board/${id}`),
};

export const adminPopupAnnouncementService = {
    getAll: (params = {}) => api.get('/admin/popup-announcements', { params }),
    create: (data) => api.post('/admin/popup-announcements', toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    update: (id, data) => api.put(`/admin/popup-announcements/${id}`, toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/admin/popup-announcements/${id}`),
};

export const adminContactService = {
    getAll: (params = {}) => api.get('/admin/contacts', { params }),
    getById: (id) => api.get(`/admin/contacts/${id}`),
    updateStatus: (id, status) => api.put(`/admin/contacts/${id}/status`, { status }),
    delete: (id) => api.delete(`/admin/contacts/${id}`),
};

export const adminVolunteerService = {
    getAll: (params = {}) => api.get('/admin/volunteers', { params }),
    getById: (id) => api.get(`/admin/volunteers/${id}`),
    updateStatus: (id, status) => api.put(`/admin/volunteers/${id}/status`, { status }),
    delete: (id) => api.delete(`/admin/volunteers/${id}`),
};

export const adminHomeSettingService = {
    get: () => api.get('/admin/home-settings'),
    update: (data) => api.post('/admin/home-settings', toFormData(data), {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
};
